export const TERMS_VERSION = "v1";
export const PRIVACY_VERSION = "v1";
